import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/index"
  },
  {
    path: "/index",
    name: "Home",
    component: Home,
    meta: {
      requireLogin: true
    }
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/login")
  }
];

const router = new VueRouter({
  mode: "history",
  base: "/material_pc",
  routes
});
//前置路由守卫
router.beforeEach((to, from, next) => {
  //to 目标路由
  //from 来源
  //next 放行
  //如果需要验证，首页守卫
  if (to.meta.requireLogin) {
    if (localStorage.getItem("token")) {
      let date = new Date().getTime();
      const tokenCreateTime = localStorage.getItem("create_time");
      const timeOver = localStorage.getItem("active_time");
      if (date - tokenCreateTime > timeOver) {
        localStorage.removeItem("token");
        localStorage.setItem("loginStatus", "false");
        this.$message.warning("登录状态已失效，请重新登录");
      }
      next();
    } else {
      //拦截路由
      localStorage.setItem("loginStatus", "false");
      next();
    }
  } else {
    //不需要验证，直接放行
    next();
  }
});
export default router;
